export class CancelException {
  constructor() {}
}
